import React from 'react';
import './Spinner.scss';
import Icon from "../../assets/icon.svg?react";

function Spinner ({height = '100%', width = '100%'}) {
  return <Icon className="icon-spinner" height={height} width={width} />
}
export default Spinner;
